import { render } from "./SettingsIndexTTS2.vue?vue&type=template&id=1370ea92&scoped=true"
import script from "./SettingsIndexTTS2.vue?vue&type=script&lang=js"
export * from "./SettingsIndexTTS2.vue?vue&type=script&lang=js"

import "./SettingsIndexTTS2.vue?vue&type=style&index=0&id=1370ea92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1370ea92"]])

export default __exports__